import useAxios from 'hooks/useAxios';

export async function createBanner(imageLink, actionRedirectLink) {
  const api = useAxios();
  const payload = { imageLink, actionRedirectLink };

  try {
    const res = await api.post('/banners', payload);
    return res;
  } catch (err) {
    return err;
  }
}


